import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { jobQueryOptions } from "@/services/job/job.options";
import { AdminJobTypeFullIndexTabContent } from "./AdminJobTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: AdminJobTypeFullIndexRoute,
});

function AdminJobTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(jobQueryOptions.jobTypeDetail(params.jobTypeId));

	const jobType = detailQuery.data ?? null;

	if (!jobType) {
		return null;
	}

	return <AdminJobTypeFullIndexTabContent tab={search.tab} jobType={jobType} />;
}
